import { defineStore } from 'pinia'

export interface NotificationItem {
  id: string
  title: string
  body: string
  data?: Record<string, any>
  receivedAt: string
}

export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    items: [] as NotificationItem[],
  }),
  actions: {
    addNotification(notification: Omit<NotificationItem, 'id' | 'receivedAt'>) {
      const item: NotificationItem = {
        id: String(Date.now()),
        receivedAt: new Date().toISOString(),
        ...notification,
      }
      this.items.unshift(item)
    },
    clearNotifications() {
      this.items = []
    },
  },
})
